import { createSlice } from "@reduxjs/toolkit";
import { Reducer } from "./Reducer";
import { InitialState } from "./Types";

export const initialState: InitialState = {
  clickedItem: undefined,
  breadcrumbSelectedItem: undefined,
};

export const Slice = createSlice({
  initialState,
  name: "breadcrumb-items",
  reducers: Reducer,
});
